module.exports = __webpack_public_path__ + "static/media/paypal.b1f7e257.png";